export const SecondsToDate = (jsDate) => {
  return new Date(jsDate.seconds * 1000);
};

export const MsToDate = (ms) => {
  return new Date(ms);
};
